import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaUsers,
  FaStore,
  FaRocket,
  FaShieldAlt,
  FaChartLine,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const MultiVendorEcommerceDevelopmentInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Multi-Vendor E-commerce Development in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Marketplace Made Simple</Subheading>}
        heading={
          <Heading>
            Multi-Vendor{" "}
            <span tw="text-primary-500">E-commerce Development</span> in Bur
            Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we excel in multi-vendor e-commerce development
            in **Bur Dubai**, creating scalable, secure platforms that connect
            multiple sellers with customers seamlessly. Build your marketplace
            and grow your business with us.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1518458028785-8fbcd101ebb9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Multi-vendor marketplace
          "https://images.unsplash.com/photo-1566241440091-ec10de8db2e1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Multiple stores/vendors
          "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Business collaboration
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Build Your Marketplace"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Multi-Vendor Solutions in Bur Dubai"
        description="We deliver powerful platforms for multi-seller success."
        cards={[
          {
            icon: <FaUsers color="#ff5464" size={40} />,
            title: "Vendor Management",
            description: "Easy tools to onboard and manage sellers.",
          },
          {
            icon: <FaStore color="#ff5464" size={40} />,
            title: "Custom Stores",
            description: "Unique storefronts for each vendor.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "High Performance",
            description: "Fast, scalable systems for growing traffic.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure Transactions",
            description: "Safe payments for vendors and customers.",
          },
          {
            icon: <FaChartLine color="#ff5464" size={40} />,
            title: "Analytics Dashboard",
            description: "Track sales and performance for all vendors.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Expertise",
            description: "Proven multi-vendor success in Bur Dubai.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Multi-Vendor Development Process"
        description={
          <Description>
            We build your marketplace with a comprehensive approach:
            <ul tw="mt-4 list-disc pl-6">
              <li>Planning: Define your marketplace goals and structure.</li>
              <li>
                Design: Create intuitive interfaces for vendors and buyers.
              </li>
              <li>Development: Build a robust multi-vendor platform.</li>
              <li>Integration: Add payment gateways and vendor tools.</li>
              <li>Testing: Ensure scalability, security, and usability.</li>
              <li>Launch: Deploy your marketplace with full support.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1472851294608-062f824d29cc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Marketplace development
          "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Business networking
          "https://images.unsplash.com/photo-1577401132920-f218ef9b01a5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Development teamwork
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Multi-Vendor Success in Bur Dubai"
        description="Our platforms have empowered local marketplaces."
        cards={[
          {
            icon: <FaStore color="#ff5464" size={40} />,
            title: "Vendor Growth",
            description: "Onboarded 30+ vendors in 3 months.",
          },
          {
            icon: <FaChartLine color="#ff5464" size={40} />,
            title: "Sales Increase",
            description: "Boosted revenue by 180% for a marketplace.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Feedback",
            description: "96% satisfaction from multi-vendor clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for a Marketplace?</Subheading>}
        heading="Multi-Vendor E-commerce in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for multi-vendor e-commerce development
            in Bur Dubai. Launch a scalable, secure marketplace that connects
            vendors and customers—start today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Team celebrating
          "https://images.unsplash.com/photo-1574362848149-11496d93a7c7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Multi-vendor concept
          "https://images.unsplash.com/photo-1560264280-88b68371db39?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Growth success
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
